import IconHsTrees from './component.jsx'
export default IconHsTrees
